import _ from 'lodash';

import CMSModel from '@/visa-application/models/CMSModel';
import AddedValueServiceCMSModel from '@/visa-application/models/AddedValueServiceCMSModel';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';
import CurrencyCMSModel from '@/visa-application/models/CurrencyCMSModel';
import FileCMSModel from '@/visa-application/models/FileCMSModel';

export default class VacAvsCMSModel implements CMSModel {
  vac: ApplicationCenterCMSModel = new ApplicationCenterCMSModel();
  avs: AddedValueServiceCMSModel = new AddedValueServiceCMSModel();
  weight: number;
  name = '';
  shortDescription = '';
  longDescription = '';
  video_url = '';
  price: number;
  currency: CurrencyCMSModel = new CurrencyCMSModel();
  valueAddedTax: number;
  more_info_url = '';
  label: 'RECOMMENDED' | 'ENHANCE' | 'OTHER' = 'OTHER';
  enable_to_confirm_as_courier_service: boolean;
  online: boolean;
  is_active = false;
  mandatory = '';
  avs_notice = '';

  map(obj: any): void {
    this.vac.map(_.get(obj, 'vac', {}));
    this.avs.map(_.get(obj, 'avs', {}));
    this.weight = _.get(obj, 'weight', 0);
    this.name = _.get(obj, 'specific_infos[0].name', '');
    this.shortDescription = _.get(obj, 'specific_infos[0].short_description', '');
    this.longDescription = _.get(obj, 'specific_infos[0].long_description', '');
    this.video_url = _.get(obj, 'specific_infos[0].video_url', '');
    this.price = _.get(obj, 'price', 0);
    this.currency.map(_.get(obj, 'currency', {}));
    this.valueAddedTax = _.get(obj, 'vat', 0);
    this.more_info_url = _.get(obj, 'more_info_url', '');
    this.label = _.get(obj, 'label', 'OTHER');
    this.enable_to_confirm_as_courier_service = _.get(obj, 'enable_to_confirm_as_courier_service', false);
    this.online = _.get(obj, 'online', false);
    this.is_active = _.get(obj, 'is_active', false);
    this.mandatory = _.get(obj, 'mandatory', '');
    this.avs_notice = _.get(obj, 'avs_notice', '');
  }
}
